export const BUTTON_ICON_POSITIONS = {
  left: "left",
  right: "right",
} as const;

export const BUTTON_SIZES = {
  sm: "sm",
  md: "md",
  lg: "lg",
} as const;

export const BUTTON_TOOLTIP_POSITIONS = {
  bottom: "bottom",
  left: "left",
  right: "right",
  top: "top",
} as const;

export const BUTTON_TYPES = {
  button: "button",
  submit: "submit",
  reset: "reset",
} as const;

export const BUTTON_VARIANTS = {
  close: "close",
  danger: "danger",
  dark: "dark",
  info: "info",
  light: "light",
  link: "link",
  primary: "primary",
  secondary: "secondary",
  success: "success",
  warning: "warning",
  custom: "custom",
  "outline-danger": "outline-danger",
  "outline-dark": "outline-dark",
  "outline-info": "outline-info",
  "outline-light": "outline-light",
  "outline-link": "outline-link",
  "outline-primary": "outline-primary",
  "outline-secondary": "outline-secondary",
  "outline-success": "outline-success",
  "outline-warning": "outline-warning",
  "outline-custom": "outline-custom",
  "table-action": "table-action",
} as const;

export const PRIMARY_COLOR = "#0e5c00";

export type ButtonType = keyof typeof BUTTON_TYPES;
export type IconType = keyof typeof BUTTON_ICON_POSITIONS;
export type SizeType = keyof typeof BUTTON_SIZES;
export type TooltipPositionType = keyof typeof BUTTON_TOOLTIP_POSITIONS;
export type VariantType = keyof typeof BUTTON_VARIANTS;
